import { jsx as _jsx } from "react/jsx-runtime";
import { HISTORY_CATEGORY_BADGE_GLYPH_VIEWBOX, HISTORY_CATEGORY_CONFIG } from "./historyCategoryConfig";
import { CategoryBadgeCircle, CategoryBadgeGlyph, HeroIconImage } from "./HXHistoryHeroIcon.styles";
export const HXHistoryHeroIcon = ({ category }) => {
    const config = HISTORY_CATEGORY_CONFIG[category];
    return _jsx(HeroIconImage, { src: config.icon, alt: "" });
};
export const HXHistoryCategoryBadgeIcon = ({ category }) => {
    const config = HISTORY_CATEGORY_CONFIG[category];
    return (_jsx(CategoryBadgeCircle, { "$bgColor": config.iconBadgeBgColor, "aria-hidden": "true", children: _jsx(CategoryBadgeGlyph, { viewBox: HISTORY_CATEGORY_BADGE_GLYPH_VIEWBOX, children: _jsx("path", { d: config.badgeGlyphPath, fill: config.badgeForegroundColor }) }) }));
};
